import { inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class LiveTvService {
  http = inject(HttpClient);

  constructor() {}

  fetchSbTvSchedule(params?: any) {
    return this.http.get(
      `${environment.mURL}${environment.endpoints.liveMatch}/${params.eventId}`,
    );
  }
}
